

import React from "react";
import {Box,Typography,Button,Card,CardContent,CardMedia,Container,Fade,Chip,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import HomeIcon from "@mui/icons-material/Home";
import PendingIcon from "@mui/icons-material/Pending";
import Footer from "../Common/Footer"
const BookingStatusScreen = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { payment_status, serviceTitle, serviceImage, selectedDate } =
    location.state || {};

  const isSuccess = payment_status === "success";
  const isCancelled = payment_status === "cancelled";
  const isFailed = payment_status === "failed";
  const isCashOnDelivery=payment_status==="pay to agent";
  const formattedDateTime = new Date(selectedDate).toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  

  const getStatusConfig = () => {
    if (isSuccess) {
      return {
        icon: <CheckCircleOutlineIcon sx={{ fontSize: 80, color: "#4caf50" }} />,
        title: "Appointment Confirmed",
        subtitle: "Your appointment has been successfully scheduled",
        message:
          "We've sent a confirmation email with all the details. Please check the app regularly for health updates and reminders.",
        chipLabel: "Confirmed",
        chipColor: "#4caf50",
        bgGradient: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)",
      };
    }
    if (isFailed) {
      return {
        icon: <ErrorOutlineIcon sx={{ fontSize: 80, color: "#f44336" }} />,
        title: "Booking Failed",
        subtitle: "We couldn't process your appointment",
        message:
          "Something went wrong during the booking process. Please try again or contact support if the issue persists.",
        chipLabel: "Failed",
        chipColor: "#f44336",
        bgGradient: "linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)",
      };
    }
    if (isCancelled) {
      return {
        icon: <CancelOutlinedIcon sx={{ fontSize: 80, color: "#ff9800" }} />,
        title: "Booking Cancelled",
        subtitle: "Your appointment has been cancelled",
        message:
          "No charges were made. You can book another appointment anytime from the services page.",
        chipLabel: "Cancelled",
        chipColor: "#ff9800",
        bgGradient: "linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)",
      };
    }
    
    if (isCashOnDelivery) {
      return {
        icon: <CheckCircleOutlineIcon sx={{ fontSize: 80, color: "#4caf50" }} />,
        title: "Appointment Confirmed",
        subtitle: "Your appointment has been successfully scheduled",
        message:
          "We've sent a confirmation email with all the details. Please check the app regularly for health updates and reminders.",
        chipLabel: "Confirmed",
        chipColor: "#4caf50",
        bgGradient: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)",
      };
    }
  };

  const statusConfig = getStatusConfig();

  return (
    <>
    <Box
      sx={{
        minHeight: "100vh",
        background: "transparent",
        py: 8,
      }}
    >
      <Container maxWidth="sm">
        {/* <IconButton
          onClick={() => navigate(-1)}
          sx={{
            mb: 3,
            bgcolor: "white",
            boxShadow: 2,
            "&:hover": { bgcolor: "#f5f5f5" },
          }}
        >
          <ArrowBackIosNewIcon />
        </IconButton> */}

        <Fade in={true} timeout={800}>
          <Card
            sx={{
              borderRadius: 4,
              boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
              overflow: "hidden",
              background: "white",
            }}
          >
            {/* Status Header */}
            <Box
              sx={{
                background: statusConfig.bgGradient,
                py: 4,
                px: 3,
                textAlign: "center",
              }}
            >
              {statusConfig.icon}
              <Typography
                variant="h4"
                sx={{
                  mt: 2,
                  fontWeight: 700,
                  color: "#1a1a1a",
                }}
              >
                {statusConfig.title}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mt: 1,
                  color: "#666",
                  fontWeight: 500,
                }}
              >
                {statusConfig.subtitle}
              </Typography>
              <Chip
                label={statusConfig.chipLabel}
                sx={{
                  mt: 2,
                  bgcolor: statusConfig.chipColor,
                  color: "white",
                  fontWeight: 600,
                  px: 2,
                }}
              />
            </Box>

            {/* Service Details */}
            <CardContent sx={{ p: 4 }}>
              {serviceImage && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mb: 3,
                  }}
                >
                  <CardMedia
                    component="img"
                    image={serviceImage}
                    alt={serviceTitle}
                    sx={{
                      height: 120,
                      width: 120,
                      objectFit: "contain",
                      borderRadius: 2,
                      border: "2px solid #f0f0f0",
                      p: 2,
                    }}
                  />
                </Box>
              )}

              <Typography
                variant="h6"
                sx={{
                  color: "#2e5d63",
                  fontWeight: 600,
                  textAlign: "center",
                  mb: 3,
                }}
              >
                {serviceTitle}
              </Typography>

              {/* Date Display (Success Only) */}
              {isSuccess && selectedDate && (
                <Box
                  sx={{
                    bgcolor: "#f8f9fa",
                    borderRadius: 2,
                    p: 2.5,
                    mb: 3,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    border: "1px solid #e0e0e0",
                  }}
                >
                  <CalendarTodayIcon sx={{ color: "#2e5d63", fontSize: 28 }} />
                  <Box>
                    <Typography
                      variant="caption"
                      sx={{
                        color: "#666",
                        fontWeight: 600,
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                      }}
                    >
                      Scheduled For
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#1a1a1a",
                        fontWeight: 600,
                        mt: 0.5,
                      }}
                    >
                     {formattedDateTime}

                    </Typography>
                  </Box>
                </Box>
              )}

              {/* Message */}
              <Typography
                variant="body2"
                sx={{
                  color: "#666",
                  lineHeight: 1.7,
                  textAlign: "center",
                  mb: 3,
                }}
              >
                {statusConfig.message}
              </Typography>

              {/* Action Buttons */}
              <Box sx={{ display: "flex", gap: 2, flexDirection: "column" }}>

                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<HomeIcon />}
                  onClick={() => navigate("/services")}
                  sx={{
                    py: 1.5,
                    borderColor: "#2e5d63",
                    color: "#2e5d63",
                    textTransform: "none",
                    fontSize: "1rem",
                    fontWeight: 600,
                    borderRadius: 2,
                    "&:hover": {
                      borderColor: "#1f4449",
                      bgcolor: "rgba(46, 93, 99, 0.04)",
                    },
                  }}
                >
                  Return to Home
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Fade>
      </Container>
    </Box>
    <Footer/>
    </>
  );
};

export default BookingStatusScreen;